import script from "./Sorter.vue?vue&type=script&setup=true&lang=js"
export * from "./Sorter.vue?vue&type=script&setup=true&lang=js"

import "./Sorter.vue?vue&type=style&index=0&id=b65ae1a0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b65ae1a0"]])

export default __exports__